<style lang="less" scoped>
    .remarks {
        background: #fff;
        .remark-content {
            padding: 16px;
        }
        .remark-content:hover {
            background: rgba(242, 244, 249, 0.6);
        }
        .remark-line {
            height: 1px;
            margin: 0 16px;
            background: rgba(0, 0, 0, 0.08);
        }
        .content-top {
            display: flex;
            justify-content: space-between;
            .top-img {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 24px;
                height: 24px;
                border-radius: 12px;
                background: var(--themeColor);
                font-size: 18px;
                font-weight: 700;
                color: #fff;
            }
            .remark-more {
                width: 24px;
                height: 24px;
                cursor: default;
            }
        }
        .content-mid {
            margin: 8px 0;
            .mid-name {
                font-size: 14px;
                font-weight: 700;
            }
            .mid-date {
                margin-left: 8px;
                font-size: 12px;
                color: var(--text-color-tertiary);
            }
        }
        .remark-content_filfull {
            .content-mid .mid-name {
                color: var(--text-color-tertiary);
            }
            .content-text {
                color: var(--text-color-tertiary);
            }
        }
        .remark-content_active {
            background: var(--bg-color-box-hover);
        }
        .remark-empty {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 160px;
        }
    }
</style>

<template>
    <div class="remarks">
        <div v-for="(item, index) in list" :key="index" @click="remarkClickHandler(item)">
            <div
                class="remark-content"
                :class="{ 'remark-content_filfull': item._completed, 'remark-content_active': activeRemarkDate === item._date }"
            >
                <div class="content-top">
                    <div class="top-img">{{ item._name.slice(0, 1) }}</div>
                    <Dropdown placement="left" @on-click="moreMenuClick($event, item)">
                        <iconSymbol class="remark-more" name="remark-more"></iconSymbol>
                        <DropdownMenu slot="list">
                            <DropdownItem name="delete">删除</DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </div>
                <div class="content-mid">
                    <span class="mid-name">{{ item._name }}</span>
                    <span class="mid-date">{{ formatDate(item._date) }}</span>
                </div>
                <div class="content-text">
                    {{ item._list[0].msg }}
                </div>
            </div>
            <div class="remark-line"></div>
        </div>
        <div v-if="list.length === 0" class="remark-empty">暂无评论</div>
    </div>
</template>

<script lang="ts">
    /**
     * @file 右侧侧边栏，评论列表
     * @author luokq
     */

    import { Component, Vue } from "vue-property-decorator";
    import dayjs from "dayjs";
    declare var egPoint: any;

    @Component({})
    export default class RemarkList extends Vue {
        list = [];
        activeRemarkDate = null;

        get isRemarkView() {
            return this.$store.state.ui.isRemarkView;
        }

        formatDate(date) {
            return dayjs(date).format("YYYY-MM-DD HH:mm");
        }

        fetchRemarkList() {
            const page = window["_view"].activePage();
            if (!this.isRemarkView || !page) {
                return;
            }
            this.list = page.getRemarks().sort((a, b) => {
                if (!a._completed && b._completed) {
                    return -1;
                }

                if (a._completed && !b._completed) {
                    return 1;
                }

                return b._date - a._date;
            });
        }

        moreMenuClick(name, item) {
            const page = window["_view"].activePage();
            if (name === "delete" && item && page) {
                page.deleteRemark(item);
                this.fetchRemarkList();
                this.$bus.$emit("refreshRemarkView");
            }
        }

        remarkClickHandler(item) {
            const page = window["_view"].activePage();
            if (page) {
                page.scrollToPt(new egPoint(item._x, item._y));
                this.activeRemarkDate = item._date;
                this.$bus.$emit("setRemarkViewActive", this.activeRemarkDate);
            }
        }

        setRemarkListActive(date) {
            this.activeRemarkDate = date;
        }

        created() {
            this.$bus.$on("refreshRemarkList", this.fetchRemarkList);
            this.$bus.$on("setRemarkListActive", this.setRemarkListActive);
        }

        mounted() {
            this.fetchRemarkList();
        }

        beforeDestroy() {
            this.$bus.$off("refreshRemarkList", this.fetchRemarkList);
            this.$bus.$off("setRemarkListActive", this.setRemarkListActive);
        }
    }
</script>
